<echarts [options]="chartOptionsCloned" [autoResize]="true" class="echart-container"></echarts>
